import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactElement } from 'react';

import type { CatalogItem } from '@/lib/quality-catalogs';
import { Select } from '@/components/ui/Select';

// Selector obligatorio de un catálogo de calidad en un formulario de alta: solo
// ofrece ítems activos (uno inactivo no admite documentos nuevos). Si el catálogo no
// carga, lo dice y ofrece reintentar (UX-ERR-01); mientras carga queda deshabilitado.

export function CatalogField({
  label,
  placeholder,
  query,
  value,
  onChange,
}: {
  label: string;
  placeholder: string;
  query: Pick<UseQueryResult<CatalogItem[]>, 'data' | 'isError' | 'refetch'>;
  value: string;
  onChange: (id: string) => void;
}): ReactElement {
  if (query.isError) {
    return (
      <div className="fld">
        <span className="fld-lab">{label}</span>
        <div className="fld-error" role="alert">
          No se pudo cargar {label.toLowerCase()}.
          <button type="button" className="btn mut sm" onClick={() => void query.refetch()}>
            Reintentar
          </button>
        </div>
      </div>
    );
  }
  const items = query.data?.filter((i) => i.isActive);
  return (
    <label className="fld">
      <span className="fld-lab">{label}</span>
      <Select
        value={value}
        disabled={items === undefined}
        placeholder={items === undefined ? 'Cargando…' : placeholder}
        options={(items ?? []).map((i) => ({ value: i.id, label: i.name }))}
        onChange={onChange}
      />
    </label>
  );
}
